<template>
  <div>
    <carrossel-imagens
      class="card card-border mb-4 produto-galeria"
      :class="{'bg-primary': !imagensProduto.length}"
      :imagens="imagensProduto"
      :fallback="base_cdn + '/static/imgs/default.png'"
      :autoplay="4000"
      setas
      zoom
      @zoom="$emit('modalImage', $event.url)"
    />
    <div>
      <h2 class="h5 m-0">{{produto.nome_produto}}</h2>
      <div v-if="produto.tabelas.length === 1 && produto.tabelas[0].principal === '0'">({{produto.tabelas[0].nome_tabela}})</div>
      <p class="m-0 text-muted" v-if="produto.descricao_produto" v-html="produto.descricao_produto"></p>
    </div>
    <div class="mt-3" v-if="produto.tabelas.length === 1">
      <aviso-informativo title="Sem estoque" class="mb-3" v-if="produto.tabelas[0].estoque === '1' && produto.tabelas[0].qtd_estoque <= 0">
        <p class="small mb-0">Este produto está indisponível no momento</p>
      </aviso-informativo>
      <produto-disponibilidade :tabela="produto.tabelas[0]" v-else/>
    </div>
  </div>
</template>

<script>
  import AvisoInformativo from './AvisoInformativo';
  import CardInfo from "./CardInfo";
  import CarrosselImagens from "./CarrosselImagens";
  import ProdutoConsumo from "./ProdutoConsumo";
  import ProdutoDisponibilidade from "./ProdutoDisponibilidade";

  /**
   * @typedef {Object} ProdutoMidia
   * @property {string} url_imagem
   *
   * @typedef {Object} ProdutoDetalhe
   * @property {string|null} url_imagem
   * @property {ProdutoMidia[]=} midias
   */

  export default {
    name: "ProdutoDescricao",
    components: {AvisoInformativo, ProdutoDisponibilidade, CarrosselImagens, ProdutoConsumo, CardInfo},
    props: {
      produto: {
        type: Object,
        required: true
      }
    },
    computed: {
      imagensProduto() {
        const imagens = Array.isArray(this.produto.midias) && this.produto.midias.length
          ? this.produto.midias
            .map(item => item && item.url_imagem)
            .filter(Boolean)
          : this.produto.url_imagem
            ? [this.produto.url_imagem]
            : [];

        return imagens.map((url, index) => ({
          id: url + '-' + index,
          url,
          alt: this.produto.nome_produto || 'Imagem do produto'
        }));
      }
    },
    filters: {
      tipo_consumo(tipo) {
        switch (tipo) {
          case '2':
            return 'apenas para retirar no local';
          case '3':
            return 'apenas para entregas';
          case '4':
            return 'apenas para consumo no local';
          case '5':
            return 'para retiradas e entregas';
          case '6':
            return 'para retiradas e consumo no local';
        }
      }
    }
  }
</script>

<style scoped>
  .card-img {
    border-radius: 16px;
    border: none;
    overflow: hidden;
  }

  .produto-galeria {
    background: #f5f5f5;
  }
</style>
